import { ref, req, withParams } from "vuelidate/lib/validators/common";
import { format } from "date-fns";

export function dateGreaterThanOrEqual(otherProperty: any) {
  return withParams({ type: "dateGreaterThanOrEqual", gt: otherProperty }, function(
    value: any,
    parentVm: any
  ) {
    // Check if a value has been passed in
    if (!req(value)) {
      return true;
    }

    // Let the other validators handle proper type validation.
    if (isNaN(Date.parse(value))) {
      return true;
    }

    // Check if the other property has a value
    const otherValue = ref(otherProperty, this, parentVm);
    if (!req(otherValue)) {
      return true;
    }

    // Only comparing the Date part of
    const newDate = format(
      value,
      "yyyy-MM-dd",
      { awareOfUnicodeTokens: true }
    );
    const otherDate = format(
      otherValue,
      "yyyy-MM-dd",
      { awareOfUnicodeTokens: true }
    );

    return newDate >= otherDate;
  });
}
